/**
 * Skins of Tia's stage (mockup tia-stage-preview.html, SKINS). A skin is DATA: the stage code reads these slots and
 * knows nothing of any particular set. One set ships — «Sanctuary of runes»; a switcher of skins is not built (AU-4 is
 * in the backlog), so adding a set later is adding an object here.
 */
export type ParticleKind = 'rune' | 'spark' | 'dust' | 'leaf';

export interface TiaSkin {
  id: string;
  /** Layer 1: the CSS background of the stage. */
  backdrop: string;
  /** Layer 5: the frame (a box-shadow). */
  frame: string;
  /** Layer 2: the particles' colour («r,g,b»), shape and base speed. */
  particle: { color: string; kind: ParticleKind; speed: number };
  /** The colour of the alcove behind Tia's portrait (the portrait is multiplied into it). */
  tint: string;
  /** Layer 4: an SVG accessory over Tia (a hat, glasses…); empty — none. */
  accessory: string;
  /** Lines of the skin that replace the default ones. */
  say?: Partial<Record<'thinking' | 'done', string>>;
}

export const SANCTUARY_SKIN: TiaSkin = {
  id: 'sanctum',
  backdrop: 'radial-gradient(120% 90% at 50% 100%, #1d3a3f 0%, #13232a 45%, #0d1418 100%)',
  frame: 'inset 0 0 0 1px rgba(127,227,234,.25)',
  particle: { color: '127,227,234', kind: 'rune', speed: 0.25 },
  tint: '#dff3f2',
  accessory: '',
};

export const DEFAULT_SKIN: TiaSkin = SANCTUARY_SKIN;
